import type { RouteConfig } from 'vue-router';

export default [
  /**
   * 身份证正反面
   * 目前用于信审流程
   */
  {
    path: '/verification/identity-card',
    meta: {
      title: '实名认证',
      excludeTracking: true,
      background: '#fff',
      customNavBar: true,
    },
    component: () => import('@/views/verification/identity-card.vue'),
  },
  /**
   * 人脸识别准备页
   * 目前用于信审/借款流程
   */
  {
    path: '/verification/face-recognition',
    meta: {
      title: '人脸验证',
      background: '#fff',
    },
    component: () => import('@/views/verification/face-recognition.vue'),
  },
  /**
   * 人脸识别结果页
   * 目前用于信审/借款流程
   */
  {
    path: '/verification/face-recognition/result',
    meta: {
      title: '人脸验证',
      background: '#fff',
    },
    component: () => import('@/views/verification/face-recognition-result.vue'),
  },
  /**
   * 人脸识别结果页
   * 主要用于重定向到小程序的识别结果页
   */
  {
    path: '/verification/face-recognition/mp/result',
    meta: {
      title: '人脸验证',
      background: '#fff',
      excludeLogin: true,
      customNavBar: true,
    },
    component: () => import('@/views/verification/face-recognition-result-within-mp.vue'),
  },
  /**
   * 人脸识别准备页
   * 目前用于CA流程
   */
  {
    path: '/verification/ca-face-recognition',
    meta: {
      title: '人脸验证',
      background: '#fff',
    },
    component: () => import('@/views/verification/ca-verification/face-recognition.vue'),
  },
  /**
   * 人脸识别结果页
   * 目前用于CA流程
   */
  {
    path: '/verification/ca-face-recognition/result',
    meta: {
      title: '人脸验证',
      background: '#fff',
    },
    component: () => import('@/views/verification/ca-verification/face-recognition-result.vue'),
  },
] as RouteConfig[];
